export const CLASS_LIST_MAP = {
  Accordion: [
    "bg-gray-100",
    "bg-transparent",
    "border",
    "border-b",
    "border-gray-200",
    "dark:bg-gray-800",
    "dark:bg-gray-900",
    "dark:bg-transparent",
    "dark:border-gray-700",
    "dark:divide-gray-700",
    "dark:focus:ring-gray-800",
    "dark:hover:bg-gray-800",
    "dark:text-gray-400",
    "dark:text-white",
    "divide-gray-200",
    "divide-y",
    "first:rounded-t-lg",
    "flex",
    "focus:ring-4",
    "focus:ring-gray-200",
    "font-medium",
    "h-6",
    "hover:bg-gray-100",
    "items-center",
    "justify-between",
    "last:rounded-b-lg",
    "p-5",
    "rotate-180",
    "rounded-lg",
    "shrink-0",
    "text-gray-500",
    "text-gray-900",
    "text-left",
    "w-6",
    "w-full",
  ],
  Alert: [
    "-m-1.5",
    "bg-blue-100",
    "bg-cyan-100",
    "bg-gray-100",
    "bg-gray-50",
    "bg-gray-800",
    "bg-green-100",
    "bg-indigo-100",
    "bg-lime-100",
    "bg-pink-100",
    "bg-purple-100",
    "bg-red-100",
    "bg-teal-100",
    "bg-yellow-100",
    "border-blue-500",
    "border-cyan-500",
    "border-gray-400",
    "border-gray-500",
    "border-gray-600",
    "border-green-500",
    "border-indigo-500",
    "border-lime-500",
    "border-pink-500",
    "border-purple-500",
    "border-red-500",
    "border-t-4",
    "border-teal-500",
    "border-yellow-500",
    "dark:bg-blue-200",
    "dark:bg-cyan-200",
    "dark:bg-gray-200",
    "dark:bg-gray-500",
    "dark:bg-gray-600",
    "dark:bg-gray-700",
    "dark:bg-gray-900",
    "dark:bg-green-200",
    "dark:bg-indigo-200",
    "dark:bg-lime-200",
    "dark:bg-pink-200",
    "dark:bg-purple-200",
    "dark:bg-red-200",
    "dark:bg-teal-200",
    "dark:bg-yellow-200",
    "dark:hover:bg-blue-300",
    "dark:hover:bg-cyan-300",
    "dark:hover:bg-gray-300",
    "dark:hover:bg-gray-700",
    "dark:hover:bg-gray-800",
    "dark:hover:bg-green-300",
    "dark:hover:bg-indigo-300",
    "dark:hover:bg-lime-300",
    "dark:hover:bg-pink-300",
    "dark:hover:bg-purple-300",
    "dark:hover:bg-red-300",
    "dark:hover:bg-teal-300",
    "dark:hover:bg-yellow-300",
    "dark:hover:text-white",
    "dark:text-blue-600",
    "dark:text-blue-800",
    "dark:text-cyan-600",
    "dark:text-cyan-800",
    "dark:text-gray-200",
    "dark:text-gray-300",
    "dark:text-gray-600",
    "dark:text-green-600",
    "dark:text-green-800",
    "dark:text-indigo-600",
    "dark:text-indigo-800",
    "dark:text-lime-600",
    "dark:text-lime-800",
    "dark:text-pink-600",
    "dark:text-pink-800",
    "dark:text-purple-600",
    "dark:text-purple-800",
    "dark:text-red-600",
    "dark:text-red-800",
    "dark:text-teal-600",
    "dark:text-teal-800",
    "dark:text-yellow-600",
    "dark:text-yellow-800",
    "flex",
    "flex-col",
    "focus:ring-2",
    "focus:ring-blue-400",
    "focus:ring-cyan-400",
    "focus:ring-gray-200",
    "focus:ring-gray-400",
    "focus:ring-green-400",
    "focus:ring-indigo-400",
    "focus:ring-lime-400",
    "focus:ring-pink-400",
    "focus:ring-purple-400",
    "focus:ring-red-400",
    "focus:ring-teal-400",
    "focus:ring-yellow-400",
    "gap-2",
    "h-5",
    "h-8",
    "hover:bg-blue-200",
    "hover:bg-cyan-200",
    "hover:bg-gray-100",
    "hover:bg-gray-200",
    "hover:bg-green-200",
    "hover:bg-indigo-200",
    "hover:bg-lime-200",
    "hover:bg-pink-200",
    "hover:bg-purple-200",
    "hover:bg-red-200",
    "hover:bg-teal-200",
    "hover:bg-yellow-200",
    "inline",
    "inline-flex",
    "items-center",
    "ml-auto",
    "mr-3",
    "p-1.5",
    "p-4",
    "rounded-lg",
    "shrink-0",
    "text-blue-500",
    "text-blue-700",
    "text-cyan-500",
    "text-cyan-700",
    "text-gray-200",
    "text-gray-500",
    "text-gray-600",
    "text-gray-700",
    "text-green-500",
    "text-green-700",
    "text-indigo-500",
    "text-indigo-700",
    "text-lime-500",
    "text-lime-700",
    "text-pink-500",
    "text-pink-700",
    "text-purple-500",
    "text-purple-700",
    "text-red-500",
    "text-red-700",
    "text-sm",
    "text-teal-500",
    "text-teal-700",
    "text-yellow-500",
    "text-yellow-700",
    "w-5",
    "w-8",
  ],
  Avatar: [
    "-bottom-1",
    "-left-1",
    "-right-1",
    "-space-x-4",
    "-top-1",
    "absolute",
    "bg-gray-100",
    "bg-gray-400",
    "bg-gray-700",
    "bg-green-400",
    "bg-red-400",
    "bg-yellow-400",
    "border-2",
    "border-white",
    "bottom-center",
    "bottom-left",
    "bottom-right",
    "center-left",
    "center-right",
    "dark:bg-gray-600",
    "dark:border-gray-800",
    "dark:ring-cyan-800",
    "dark:ring-gray-400",
    "dark:ring-gray-500",
    "dark:ring-gray-800",
    "dark:ring-green-500",
    "dark:ring-pink-500",
    "dark:ring-purple-600",
    "dark:ring-red-700",
    "dark:ring-yellow-500",
    "dark:text-gray-300",
    "flex",
    "font-medium",
    "h-10",
    "h-20",
    "h-3.5",
    "h-36",
    "h-6",
    "h-8",
    "h-auto",
    "hover:bg-gray-600",
    "inline-flex",
    "items-center",
    "justify-center",
    "overflow-hidden",
    "p-1",
    "relative",
    "ring-2",
    "ring-cyan-400",
    "ring-gray-300",
    "ring-gray-500",
    "ring-gray-800",
    "ring-green-500",
    "ring-pink-500",
    "ring-purple-500",
    "ring-red-500",
    "ring-yellow-300",
    "rounded",
    "rounded-full",
    "space-x-4",
    "text-gray-400",
    "text-gray-600",
    "text-white",
    "text-xs",
    "top-center",
    "top-left",
    "top-right",
    "w-10",
    "w-20",
    "w-3.5",
    "w-36",
    "w-6",
    "w-8",
    "w-auto",
  ],
  Badge: [
    "bg-blue-100",
    "bg-cyan-100",
    "bg-gray-100",
    "bg-gray-200",
    "bg-gray-600",
    "bg-green-100",
    "bg-indigo-100",
    "bg-lime-100",
    "bg-pink-100",
    "bg-purple-100",
    "bg-red-100",
    "bg-teal-100",
    "bg-yellow-100",
    "dark:bg-blue-200",
    "dark:bg-cyan-200",
    "dark:bg-gray-400",
    "dark:bg-gray-700",
    "dark:bg-gray-900",
    "dark:bg-green-200",
    "dark:bg-indigo-200",
    "dark:bg-lime-200",
    "dark:bg-pink-200",
    "dark:bg-purple-200",
    "dark:bg-red-200",
    "dark:bg-teal-200",
    "dark:bg-yellow-200",
    "dark:hover:bg-blue-300",
    "dark:hover:bg-cyan-300",
    "dark:hover:bg-gray-500",
    "dark:hover:bg-gray-600",
    "dark:hover:bg-gray-700",
    "dark:hover:bg-green-300",
    "dark:hover:bg-indigo-300",
    "dark:hover:bg-lime-300",
    "dark:hover:bg-pink-300",
    "dark:hover:bg-purple-300",
    "dark:hover:bg-red-300",
    "dark:hover:bg-teal-300",
    "dark:hover:bg-yellow-300",
    "dark:text-blue-900",
    "dark:text-cyan-800",
    "dark:text-cyan-900",
    "dark:text-gray-200",
    "dark:text-gray-300",
    "dark:text-gray-900",
    "dark:text-green-900",
    "dark:text-indigo-900",
    "dark:text-lime-900",
    "dark:text-pink-900",
    "dark:text-purple-900",
    "dark:text-red-900",
    "dark:text-teal-900",
    "dark:text-yellow-900",
    "flex",
    "font-semibold",
    "gap-1",
    "h-3",
    "h-3.5",
    "h-fit",
    "hover:bg-blue-200",
    "hover:bg-cyan-200",
    "hover:bg-gray-200",
    "hover:bg-gray-300",
    "hover:bg-gray-500",
    "hover:bg-green-200",
    "hover:bg-indigo-200",
    "hover:bg-lime-200",
    "hover:bg-pink-200",
    "hover:bg-purple-200",
    "hover:bg-red-200",
    "hover:bg-teal-200",
    "hover:bg-yellow-200",
    "items-center",
    "p-1",
    "p-1.5",
    "px-2",
    "py-0.5",
    "rounded",
    "rounded-full",
    "text-blue-800",
    "text-cyan-800",
    "text-gray-100",
    "text-gray-800",
    "text-green-800",
    "text-indigo-800",
    "text-lime-800",
    "text-pink-800",
    "text-purple-800",
    "text-red-800",
    "text-sm",
    "text-teal-800",
    "text-xs",
    "text-yellow-800",
    "w-3",
    "w-3.5",
  ],
  Banner: [],
  Blockquote: [
    "dark:text-white",
    "font-semibold",
    "italic",
    "text-gray-900",
    "text-xl",
  ],
  Breadcrumb: [
    "dark:hover:text-white",
    "dark:text-gray-400",
    "flex",
    "font-medium",
    "group",
    "group-first:hidden",
    "h-4",
    "hover:text-gray-900",
    "items-center",
    "md:mx-2",
    "mr-2",
    "mx-1",
    "text-gray-400",
    "text-gray-500",
    "text-gray-700",
    "text-sm",
    "w-4",
  ],
  Button: [
    "bg-blue-700",
    "bg-cyan-700",
    "bg-gray-700",
    "bg-gray-800",
    "bg-green-700",
    "bg-indigo-700",
    "bg-lime-700",
    "bg-pink-700",
    "bg-primary-700",
    "bg-purple-700",
    "bg-red-700",
    "bg-teal-700",
    "bg-white",
    "bg-yellow-400",
    "border",
    "border-blue-700",
    "border-cyan-700",
    "border-gray-200",
    "border-gray-300",
    "border-gray-700",
    "border-gray-800",
    "border-green-700",
    "border-indigo-700",
    "border-l-0",
    "border-lime-700",
    "border-pink-700",
    "border-primary-700",
    "border-purple-700",
    "border-red-700",
    "border-teal-700",
    "border-yellow-400",
    "dark:bg-blue-600",
    "dark:bg-cyan-600",
    "dark:bg-gray-600",
    "dark:bg-gray-800",
    "dark:bg-green-600",
    "dark:bg-indigo-600",
    "dark:bg-lime-600",
    "dark:bg-pink-600",
    "dark:bg-primary-600",
    "dark:bg-purple-600",
    "dark:bg-red-600",
    "dark:bg-teal-600",
    "dark:bg-yellow-600",
    "dark:border-blue-500",
    "dark:border-cyan-500",
    "dark:border-gray-600",
    "dark:border-green-600",
    "dark:border-indigo-600",
    "dark:border-lime-600",
    "dark:border-pink-600",
    "dark:border-primary-600",
    "dark:border-purple-600",
    "dark:border-red-600",
    "dark:border-teal-600",
    "dark:border-yellow-300",
    "dark:focus:ring-blue-800",
    "dark:focus:ring-cyan-800",
    "dark:focus:ring-gray-700",
    "dark:focus:ring-gray-800",
    "dark:focus:ring-green-800",
    "dark:focus:ring-indigo-800",
    "dark:focus:ring-lime-800",
    "dark:focus:ring-pink-800",
    "dark:focus:ring-primary-800",
    "dark:focus:ring-purple-800",
    "dark:focus:ring-red-800",
    "dark:focus:ring-teal-800",
    "dark:focus:ring-yellow-900",
    "dark:hover:bg-blue-700",
    "dark:hover:bg-cyan-700",
    "dark:hover:bg-gray-600",
    "dark:hover:bg-gray-700",
    "dark:hover:bg-green-700",
    "dark:hover:bg-indigo-700",
    "dark:hover:bg-lime-700",
    "dark:hover:bg-pink-700",
    "dark:hover:bg-primary-700",
    "dark:hover:bg-purple-700",
    "dark:hover:bg-red-700",
    "dark:hover:bg-teal-700",
    "dark:hover:bg-yellow-400",
    "dark:hover:border-blue-700",
    "dark:hover:border-cyan-700",
    "dark:hover:border-gray-600",
    "dark:hover:border-gray-700",
    "dark:hover:border-green-700",
    "dark:hover:border-indigo-700",
    "dark:hover:border-lime-700",
    "dark:hover:border-pink-700",
    "dark:hover:border-primary-700",
    "dark:hover:border-purple-700",
    "dark:hover:border-red-700",
    "dark:hover:border-teal-700",
    "dark:hover:border-yellow-400",
    "dark:hover:text-white",
    "dark:text-blue-500",
    "dark:text-cyan-500",
    "dark:text-gray-400",
    "dark:text-green-500",
    "dark:text-indigo-400",
    "dark:text-lime-500",
    "dark:text-pink-500",
    "dark:text-primary-500",
    "dark:text-purple-400",
    "dark:text-red-500",
    "dark:text-teal-400",
    "dark:text-white",
    "dark:text-yellow-300",
    "first:border-l",
    "first:rounded-s-lg",
    "flex",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-4",
    "focus:ring-blue-300",
    "focus:ring-cyan-300",
    "focus:ring-gray-100",
    "focus:ring-gray-300",
    "focus:ring-green-300",
    "focus:ring-indigo-300",
    "focus:ring-lime-300",
    "focus:ring-pink-300",
    "focus:ring-primary-300",
    "focus:ring-purple-300",
    "focus:ring-red-300",
    "focus:ring-teal-300",
    "focus:ring-yellow-300",
    "font-medium",
    "h-10",
    "h-12",
    "h-8",
    "h-9",
    "h-[52px]",
    "hover:bg-blue-800",
    "hover:bg-cyan-800",
    "hover:bg-gray-100",
    "hover:bg-gray-800",
    "hover:bg-gray-900",
    "hover:bg-green-800",
    "hover:bg-indigo-800",
    "hover:bg-lime-800",
    "hover:bg-pink-800",
    "hover:bg-primary-800",
    "hover:bg-purple-800",
    "hover:bg-red-800",
    "hover:bg-teal-800",
    "hover:bg-yellow-500",
    "hover:border-blue-800",
    "hover:border-cyan-800",
    "hover:border-gray-800",
    "hover:border-gray-900",
    "hover:border-green-800",
    "hover:border-indigo-800",
    "hover:border-lime-800",
    "hover:border-pink-800",
    "hover:border-primary-800",
    "hover:border-purple-800",
    "hover:border-red-800",
    "hover:border-teal-800",
    "hover:border-yellow-500",
    "hover:text-primary-700",
    "hover:text-white",
    "inline-flex",
    "items-center",
    "justify-center",
    "last:rounded-e-lg",
    "opacity-50",
    "pointer-events-none",
    "px-3",
    "px-5",
    "px-6",
    "relative",
    "rounded-full",
    "rounded-lg",
    "rounded-md",
    "rounded-none",
    "shadow-sm",
    "text-base",
    "text-blue-700",
    "text-center",
    "text-cyan-700",
    "text-gray-700",
    "text-gray-800",
    "text-gray-900",
    "text-green-700",
    "text-indigo-700",
    "text-lime-700",
    "text-pink-700",
    "text-primary-700",
    "text-purple-700",
    "text-red-700",
    "text-sm",
    "text-teal-700",
    "text-white",
    "text-xs",
    "text-yellow-400",
    "w-full",
  ],
  Card: [
    "bg-white",
    "border",
    "border-gray-200",
    "dark:bg-gray-800",
    "dark:border-gray-700",
    "dark:hover:bg-gray-700",
    "flex",
    "flex-col",
    "gap-4",
    "h-96",
    "h-full",
    "hover:bg-gray-100",
    "justify-center",
    "md:flex-row",
    "md:h-auto",
    "md:max-w-xl",
    "md:rounded-l-lg",
    "md:rounded-none",
    "md:w-48",
    "object-cover",
    "p-6",
    "rounded-lg",
    "rounded-t-lg",
    "shadow-md",
    "w-full",
  ],
  Carousel: [
    "-translate-x-1/2",
    "-translate-y-1/2",
    "absolute",
    "bg-white",
    "bg-white/30",
    "bg-white/50",
    "block",
    "bottom-5",
    "cursor-default",
    "cursor-grab",
    "dark:bg-gray-800",
    "dark:bg-gray-800/30",
    "dark:bg-gray-800/50",
    "dark:group-focus:ring-gray-800/70",
    "dark:group-hover:bg-gray-800/60",
    "dark:hover:bg-gray-800",
    "dark:text-gray-800",
    "flex",
    "focus:outline-none",
    "group-focus:outline-none",
    "group-focus:ring-4",
    "group-focus:ring-white",
    "group-hover:bg-white/50",
    "h-3",
    "h-5",
    "h-8",
    "h-full",
    "hover:bg-white",
    "inline-flex",
    "items-center",
    "justify-center",
    "left-0",
    "left-1/2",
    "overflow-x-scroll",
    "overflow-y-hidden",
    "px-4",
    "relative",
    "right-0",
    "rounded-full",
    "rounded-lg",
    "scroll-smooth",
    "shrink-0",
    "sm:h-10",
    "sm:h-6",
    "sm:w-10",
    "sm:w-6",
    "snap-center",
    "snap-mandatory",
    "snap-x",
    "space-x-3",
    "text-white",
    "top-0",
    "top-1/2",
    "transform",
    "w-3",
    "w-5",
    "w-8",
    "w-full",
  ],
  Checkbox: [
    "appearance-none",
    "bg-[length:0.55em_0.55em]",
    "bg-center",
    "bg-current",
    "bg-dash-icon",
    "bg-gray-100",
    "bg-no-repeat",
    "border",
    "border-gray-300",
    "border-transparent",
    "checked:bg-check-icon",
    "checked:bg-current",
    "checked:border-transparent",
    "dark:bg-current",
    "dark:bg-gray-700",
    "dark:border-gray-600",
    "dark:border-transparent",
    "dark:checked:bg-current",
    "dark:checked:border-transparent",
    "dark:focus:ring-blue-700",
    "dark:focus:ring-cyan-600",
    "dark:focus:ring-cyan-800",
    "dark:focus:ring-gray-800",
    "dark:focus:ring-gray-900",
    "dark:focus:ring-green-600",
    "dark:focus:ring-green-800",
    "dark:focus:ring-indigo-700",
    "dark:focus:ring-lime-700",
    "dark:focus:ring-pink-600",
    "dark:focus:ring-primary-600",
    "dark:focus:ring-purple-600",
    "dark:focus:ring-red-600",
    "dark:focus:ring-red-900",
    "dark:focus:ring-teal-600",
    "dark:focus:ring-yellow-400",
    "dark:ring-offset-blue-700",
    "dark:ring-offset-cyan-600",
    "dark:ring-offset-gray-800",
    "dark:ring-offset-gray-900",
    "dark:ring-offset-green-600",
    "dark:ring-offset-green-800",
    "dark:ring-offset-indigo-700",
    "dark:ring-offset-lime-700",
    "dark:ring-offset-pink-600",
    "dark:ring-offset-purple-600",
    "dark:ring-offset-red-600",
    "dark:ring-offset-red-900",
    "dark:ring-offset-teal-600",
    "dark:ring-offset-yellow-400",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-blue-600",
    "focus:ring-cyan-600",
    "focus:ring-cyan-800",
    "focus:ring-gray-800",
    "focus:ring-gray-900",
    "focus:ring-green-600",
    "focus:ring-green-800",
    "focus:ring-indigo-700",
    "focus:ring-lime-700",
    "focus:ring-offset-2",
    "focus:ring-pink-600",
    "focus:ring-primary-600",
    "focus:ring-purple-600",
    "focus:ring-red-600",
    "focus:ring-red-900",
    "focus:ring-teal-600",
    "focus:ring-yellow-400",
    "h-4",
    "rounded",
    "text-blue-700",
    "text-cyan-600",
    "text-cyan-800",
    "text-gray-800",
    "text-gray-900",
    "text-green-600",
    "text-green-800",
    "text-indigo-700",
    "text-lime-700",
    "text-pink-600",
    "text-primary-600",
    "text-purple-600",
    "text-red-600",
    "text-red-900",
    "text-teal-600",
    "text-yellow-400",
    "w-4",
  ],
  Clipboard: [
    "-translate-y-1/2",
    "absolute",
    "bg-blue-700",
    "bg-white",
    "border",
    "border-gray-200",
    "dark:bg-blue-600",
    "dark:bg-gray-800",
    "dark:border-gray-600",
    "dark:focus:ring-blue-800",
    "dark:hover:bg-blue-700",
    "dark:hover:bg-gray-700",
    "dark:hover:bg-gray-800",
    "dark:text-blue-500",
    "dark:text-gray-400",
    "end-2",
    "end-2.5",
    "focus:outline-none",
    "focus:ring-4",
    "focus:ring-blue-300",
    "font-medium",
    "font-semibold",
    "h-3",
    "h-4",
    "hover:bg-blue-800",
    "hover:bg-gray-100",
    "inline-flex",
    "items-center",
    "justify-center",
    "me-1.5",
    "p-2",
    "px-2.5",
    "px-5",
    "py-2",
    "py-3",
    "rounded-lg",
    "sm:w-auto",
    "text-blue-700",
    "text-center",
    "text-gray-500",
    "text-gray-900",
    "text-sm",
    "text-white",
    "text-xs",
    "top-1/2",
    "w-3",
    "w-4",
    "w-full",
  ],
  DarkThemeToggle: [
    "dark:block",
    "dark:focus:ring-gray-700",
    "dark:hidden",
    "dark:hover:bg-gray-700",
    "dark:text-gray-400",
    "focus:outline-none",
    "focus:ring-4",
    "focus:ring-gray-200",
    "h-5",
    "hidden",
    "hover:bg-gray-100",
    "p-2.5",
    "rounded-lg",
    "text-gray-500",
    "text-sm",
    "w-5",
  ],
  Datepicker: [
    "absolute",
    "bg-cyan-700",
    "bg-white",
    "block",
    "border",
    "border-0",
    "border-gray-300",
    "cursor-pointer",
    "dark:bg-cyan-600",
    "dark:bg-gray-700",
    "dark:border-gray-600",
    "dark:hover:bg-cyan-700",
    "dark:hover:bg-gray-600",
    "dark:text-gray-400",
    "dark:text-white",
    "flex",
    "flex-1",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-4",
    "focus:ring-cyan-300",
    "focus:ring-gray-200",
    "font-medium",
    "font-semibold",
    "grid",
    "grid-cols-4",
    "grid-cols-7",
    "h-6",
    "hover:bg-cyan-600",
    "hover:bg-cyan-800",
    "hover:bg-gray-100",
    "inline-block",
    "justify-between",
    "leading-6",
    "leading-9",
    "mb-1",
    "mb-2",
    "mt-2",
    "p-1",
    "p-4",
    "pt-2",
    "px-2",
    "px-5",
    "py-2",
    "py-2.5",
    "py-3",
    "relative",
    "rounded-lg",
    "shadow-lg",
    "space-x-2",
    "text-center",
    "text-gray-500",
    "text-gray-900",
    "text-sm",
    "text-white",
    "top-0",
    "top-10",
    "w-64",
    "w-full",
    "z-50",
    "z-auto",
  ],
  Drawer: [
    "-translate-x-full",
    "-translate-y-full",
    "absolute",
    "bg-gray-900/50",
    "bg-transparent",
    "bg-white",
    "block",
    "bottom-0",
    "bottom-16",
    "dark:bg-gray-800",
    "dark:bg-gray-900/80",
    "dark:hover:bg-gray-600",
    "dark:hover:text-white",
    "dark:text-gray-400",
    "end-2.5",
    "fixed",
    "flex",
    "font-semibold",
    "h-4",
    "h-8",
    "h-screen",
    "hidden",
    "hover:bg-gray-200",
    "hover:text-gray-900",
    "inline-flex",
    "inset-0",
    "items-center",
    "justify-center",
    "left-0",
    "mb-4",
    "me-2.5",
    "overflow-y-auto",
    "p-4",
    "right-0",
    "rounded-lg",
    "text-base",
    "text-gray-400",
    "text-gray-500",
    "text-sm",
    "top-0",
    "top-2.5",
    "transform-none",
    "transition-transform",
    "translate-x-full",
    "translate-y-full",
    "w-4",
    "w-8",
    "w-80",
    "w-full",
    "z-30",
    "z-40",
  ],
  Dropdown: [
    "-4px",
    "absolute",
    "bg-gray-100",
    "bg-gray-900",
    "bg-white",
    "block",
    "border",
    "border-gray-200",
    "cursor-pointer",
    "dark:bg-gray-600",
    "dark:bg-gray-700",
    "dark:border-none",
    "dark:focus:bg-gray-600",
    "dark:focus:text-white",
    "dark:hover:bg-gray-600",
    "dark:hover:text-white",
    "dark:text-gray-200",
    "dark:text-white",
    "divide-gray-100",
    "divide-y",
    "flex",
    "focus:bg-gray-100",
    "focus:outline-none",
    "h-2",
    "h-4",
    "h-px",
    "hover:bg-gray-100",
    "invisible",
    "items-center",
    "justify-start",
    "ml-2",
    "mr-2",
    "my-1",
    "opacity-0",
    "px-4",
    "py-1",
    "py-2",
    "rotate-45",
    "rounded",
    "shadow",
    "text-gray-700",
    "text-gray-900",
    "text-sm",
    "text-white",
    "transition-opacity",
    "w-2",
    "w-4",
    "w-fit",
    "w-full",
    "z-10",
  ],
  FileInput: [
    "bg-cyan-50",
    "bg-gray-50",
    "bg-green-50",
    "bg-red-50",
    "bg-yellow-50",
    "block",
    "border",
    "border-cyan-500",
    "border-gray-300",
    "border-green-500",
    "border-red-500",
    "border-yellow-500",
    "cursor-pointer",
    "dark:bg-cyan-100",
    "dark:bg-gray-700",
    "dark:bg-green-100",
    "dark:bg-red-100",
    "dark:bg-yellow-100",
    "dark:border-cyan-400",
    "dark:border-gray-600",
    "dark:border-green-400",
    "dark:border-red-400",
    "dark:border-yellow-400",
    "dark:file:bg-gray-600",
    "dark:focus:border-cyan-500",
    "dark:focus:border-green-500",
    "dark:focus:border-primary-500",
    "dark:focus:border-red-500",
    "dark:focus:border-yellow-500",
    "dark:focus:ring-cyan-500",
    "dark:focus:ring-green-500",
    "dark:focus:ring-primary-500",
    "dark:focus:ring-red-500",
    "dark:focus:ring-yellow-500",
    "dark:hover:file:bg-gray-500",
    "dark:placeholder-gray-400",
    "dark:text-gray-400",
    "file:-ms-4",
    "file:bg-gray-800",
    "file:border-none",
    "file:cursor-pointer",
    "file:font-medium",
    "file:leading-[inherit]",
    "file:me-4",
    "file:pe-4",
    "file:ps-8",
    "file:py-2.5",
    "file:text-sm",
    "file:text-white",
    "focus:border-cyan-500",
    "focus:border-green-500",
    "focus:border-primary-500",
    "focus:border-red-500",
    "focus:border-yellow-500",
    "focus:outline-none",
    "focus:ring-1",
    "focus:ring-cyan-500",
    "focus:ring-green-500",
    "focus:ring-primary-500",
    "focus:ring-red-500",
    "focus:ring-yellow-500",
    "hover:file:bg-gray-700",
    "placeholder-cyan-700",
    "placeholder-green-700",
    "placeholder-red-700",
    "placeholder-yellow-700",
    "rounded-lg",
    "text-cyan-900",
    "text-gray-900",
    "text-green-900",
    "text-lg",
    "text-red-900",
    "text-sm",
    "text-xs",
    "text-yellow-900",
    "w-full",
  ],
  FloatingLabel: [
    "-translate-y-4",
    "-translate-y-6",
    "-z-10",
    "absolute",
    "appearance-none",
    "bg-gray-50",
    "bg-transparent",
    "bg-white",
    "block",
    "border",
    "border-0",
    "border-b-2",
    "border-gray-300",
    "border-green-600",
    "border-red-600",
    "dark:bg-gray-700",
    "dark:bg-gray-900",
    "dark:border-gray-600",
    "dark:border-green-500",
    "dark:border-red-500",
    "dark:focus:border-green-500",
    "dark:focus:border-primary-500",
    "dark:focus:border-red-500",
    "dark:text-gray-400",
    "dark:text-green-500",
    "dark:text-red-500",
    "dark:text-white",
    "duration-300",
    "focus:border-green-600",
    "focus:border-primary-600",
    "focus:border-red-600",
    "focus:outline-none",
    "focus:ring-0",
    "left-1",
    "left-2.5",
    "origin-[0]",
    "pb-2.5",
    "peer",
    "peer-focus:-translate-y-4",
    "peer-focus:-translate-y-6",
    "peer-focus:dark:text-primary-500",
    "peer-focus:left-0",
    "peer-focus:px-2",
    "peer-focus:scale-75",
    "peer-focus:text-primary-600",
    "peer-focus:top-2",
    "peer-placeholder-shown:-translate-y-1/2",
    "peer-placeholder-shown:scale-100",
    "peer-placeholder-shown:top-1/2",
    "peer-placeholder-shown:translate-y-0",
    "pt-4",
    "pt-5",
    "px-0",
    "px-2",
    "px-2.5",
    "py-2.5",
    "rounded-lg",
    "rounded-t-lg",
    "scale-75",
    "text-gray-500",
    "text-gray-900",
    "text-green-600",
    "text-red-600",
    "text-sm",
    "text-xs",
    "top-2",
    "top-3",
    "top-4",
    "transition-transform",
    "w-full",
    "z-10",
  ],
  Footer: [
    "bg-gray-800",
    "bg-white",
    "border-gray-200",
    "dark:bg-gray-800",
    "dark:border-gray-700",
    "dark:hover:text-white",
    "dark:text-gray-400",
    "dark:text-white",
    "flex",
    "flex-col",
    "flex-wrap",
    "font-semibold",
    "h-5",
    "h-8",
    "hover:underline",
    "items-center",
    "last:mr-0",
    "lg:my-8",
    "mb-4",
    "mb-6",
    "md:flex",
    "md:items-center",
    "md:justify-between",
    "md:mr-6",
    "me-4",
    "ml-1",
    "mr-3",
    "my-6",
    "p-6",
    "rounded-lg",
    "self-center",
    "shadow",
    "sm:mb-0",
    "sm:mx-auto",
    "sm:text-center",
    "space-y-4",
    "text-2xl",
    "text-gray-500",
    "text-gray-800",
    "text-sm",
    "uppercase",
    "w-5",
    "w-full",
    "whitespace-nowrap",
  ],
  HR: [
    "-translate-x-1/2",
    "absolute",
    "bg-gray-100",
    "bg-gray-200",
    "bg-white",
    "border-0",
    "dark:bg-gray-700",
    "dark:bg-gray-900",
    "dark:text-gray-300",
    "dark:text-white",
    "font-medium",
    "h-1",
    "h-4",
    "h-8",
    "h-px",
    "inline-flex",
    "items-center",
    "justify-center",
    "left-1/2",
    "md:my-10",
    "md:my-12",
    "mx-auto",
    "my-4",
    "my-8",
    "px-3",
    "px-4",
    "rounded",
    "text-gray-700",
    "text-gray-900",
    "w-4",
    "w-48",
    "w-64",
    "w-8",
    "w-full",
  ],
  HelperText: [
    "dark:text-cyan-800",
    "dark:text-gray-300",
    "dark:text-green-500",
    "dark:text-red-500",
    "dark:text-yellow-600",
    "mt-2",
    "text-cyan-700",
    "text-gray-500",
    "text-green-600",
    "text-red-600",
    "text-sm",
    "text-yellow-500",
  ],
  Kbd: [
    "bg-gray-100",
    "border",
    "border-gray-200",
    "dark:bg-gray-600",
    "dark:border-gray-500",
    "dark:text-gray-100",
    "font-semibold",
    "inline-block",
    "px-2",
    "py-1.5",
    "rounded-lg",
    "text-gray-800",
    "text-xs",
  ],
  Label: [
    "dark:text-cyan-600",
    "dark:text-green-500",
    "dark:text-red-500",
    "dark:text-white",
    "dark:text-yellow-600",
    "font-medium",
    "opacity-50",
    "text-cyan-500",
    "text-gray-900",
    "text-green-700",
    "text-red-700",
    "text-sm",
    "text-yellow-500",
  ],
  List: [
    "dark:text-gray-400",
    "flex",
    "flex-wrap",
    "h-3.5",
    "items-center",
    "justify-center",
    "list-decimal",
    "list-disc",
    "list-inside",
    "list-none",
    "me-2",
    "mt-2",
    "ps-5",
    "shrink-0",
    "space-x-4",
    "space-y-0",
    "space-y-1",
    "text-gray-500",
    "w-3.5",
  ],
  ListGroup: [
    "[&>*]:first:rounded-t-lg",
    "[&>*]:last:border-b-0",
    "[&>*]:last:rounded-b-lg",
    "bg-cyan-700",
    "bg-gray-100",
    "bg-white",
    "border",
    "border-b",
    "border-gray-200",
    "cursor-not-allowed",
    "dark:bg-gray-700",
    "dark:bg-gray-800",
    "dark:border-gray-600",
    "dark:focus:ring-gray-500",
    "dark:focus:text-white",
    "dark:hover:bg-gray-600",
    "dark:hover:text-white",
    "dark:text-white",
    "fill-current",
    "flex",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-cyan-700",
    "focus:text-cyan-700",
    "focus:text-gray-900",
    "font-medium",
    "h-4",
    "hover:bg-gray-100",
    "hover:text-cyan-700",
    "hover:text-gray-900",
    "items-center",
    "list-none",
    "mr-2",
    "px-4",
    "py-2",
    "rounded-lg",
    "text-gray-900",
    "text-left",
    "text-sm",
    "text-white",
    "w-4",
    "w-full",
  ],
  MegaMenu: [
    "block",
    "dark:text-gray-400",
    "flex",
    "items-center",
    "justify-between",
    "mt-2",
    "text-gray-500",
    "w-full",
  ],
  Modal: [
    "2xl",
    "3xl",
    "4xl",
    "5xl",
    "6xl",
    "7xl",
    "bg-gray-900/50",
    "bg-transparent",
    "bg-white",
    "border-b",
    "border-b-0",
    "border-gray-200",
    "border-t",
    "bottom-center",
    "bottom-left",
    "bottom-right",
    "center-left",
    "center-right",
    "dark:bg-gray-700",
    "dark:bg-gray-900/80",
    "dark:border-gray-600",
    "dark:hover:bg-gray-600",
    "dark:hover:text-white",
    "dark:text-white",
    "fixed",
    "flex",
    "flex-1",
    "flex-col",
    "font-medium",
    "h-5",
    "h-full",
    "h-screen",
    "hidden",
    "hover:bg-gray-200",
    "hover:text-gray-900",
    "inline-flex",
    "inset-x-0",
    "items-center",
    "items-end",
    "items-start",
    "justify-between",
    "justify-center",
    "justify-end",
    "justify-start",
    "max-h-[90dvh]",
    "max-w-2xl",
    "max-w-3xl",
    "max-w-4xl",
    "max-w-5xl",
    "max-w-6xl",
    "max-w-7xl",
    "max-w-lg",
    "max-w-md",
    "max-w-sm",
    "max-w-xl",
    "md:h-auto",
    "md:h-full",
    "md:inset-0",
    "ml-auto",
    "overflow-auto",
    "overflow-x-hidden",
    "overflow-y-auto",
    "p-1.5",
    "p-2",
    "p-4",
    "p-5",
    "p-6",
    "pt-0",
    "relative",
    "rounded-b",
    "rounded-lg",
    "rounded-t",
    "shadow",
    "space-x-2",
    "text-gray-400",
    "text-gray-900",
    "text-sm",
    "text-xl",
    "top-0",
    "top-center",
    "top-left",
    "top-right",
    "w-5",
    "w-full",
    "z-50",
  ],
  Navbar: [
    "bg-primary-700",
    "bg-white",
    "block",
    "border",
    "border-b",
    "border-gray-100",
    "container",
    "dark:bg-gray-800",
    "dark:border-gray-700",
    "dark:focus:ring-gray-600",
    "dark:hover:bg-gray-700",
    "dark:hover:text-white",
    "dark:text-gray-400",
    "dark:text-gray-600",
    "dark:text-white",
    "flex",
    "flex-col",
    "flex-wrap",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-gray-200",
    "h-6",
    "hidden",
    "hover:bg-gray-100",
    "hover:bg-gray-50",
    "hover:cursor-not-allowed",
    "inline-flex",
    "items-center",
    "justify-between",
    "md:bg-transparent",
    "md:block",
    "md:border-0",
    "md:dark:hover:bg-transparent",
    "md:dark:hover:text-white",
    "md:flex-row",
    "md:font-medium",
    "md:hidden",
    "md:hover:bg-transparent",
    "md:hover:text-primary-700",
    "md:mt-0",
    "md:p-0",
    "md:space-x-8",
    "md:text-primary-700",
    "md:text-sm",
    "md:w-auto",
    "mt-4",
    "mx-auto",
    "p-2",
    "pl-3",
    "pr-4",
    "px-2",
    "py-2",
    "py-2.5",
    "rounded",
    "rounded-lg",
    "shrink-0",
    "sm:px-4",
    "text-gray-400",
    "text-gray-500",
    "text-gray-700",
    "text-sm",
    "text-white",
    "w-6",
    "w-full",
  ],
  Pagination: [
    "-space-x-px",
    "bg-cyan-50",
    "bg-white",
    "border",
    "border-gray-300",
    "cursor-not-allowed",
    "dark:bg-gray-700",
    "dark:bg-gray-800",
    "dark:border-gray-700",
    "dark:text-gray-400",
    "dark:text-white",
    "enabled:dark:hover:bg-gray-700",
    "enabled:dark:hover:text-white",
    "enabled:hover:bg-gray-100",
    "enabled:hover:text-gray-700",
    "font-semibold",
    "h-5",
    "hover:bg-cyan-100",
    "hover:text-cyan-700",
    "inline-flex",
    "items-center",
    "leading-tight",
    "ml-0",
    "mt-2",
    "opacity-50",
    "px-3",
    "py-2",
    "rounded-l-lg",
    "rounded-r-lg",
    "text-cyan-600",
    "text-gray-500",
    "text-gray-700",
    "text-gray-900",
    "text-sm",
    "w-12",
    "w-5",
    "xs:mt-0",
  ],
  Popover: [
    "-4px",
    "absolute",
    "bg-white",
    "border",
    "border-gray-200",
    "dark:bg-gray-800",
    "dark:border-gray-600",
    "dark:mix-blend-color",
    "h-2",
    "inline-block",
    "max-w-[100vw]",
    "mix-blend-lighten",
    "outline-none",
    "overflow-hidden",
    "rotate-45",
    "rounded-[7px]",
    "rounded-lg",
    "shadow-sm",
    "w-2",
    "w-max",
    "z-0",
    "z-10",
    "z-20",
  ],
  Progress: [
    "bg-blue-600",
    "bg-cyan-600",
    "bg-gray-200",
    "bg-gray-500",
    "bg-gray-600",
    "bg-green-600",
    "bg-indigo-600",
    "bg-lime-600",
    "bg-pink-500",
    "bg-primary-600",
    "bg-purple-600",
    "bg-red-600",
    "bg-teal-600",
    "bg-yellow-400",
    "dark:bg-gray-300",
    "dark:bg-gray-700",
    "dark:bg-green-500",
    "dark:bg-indigo-500",
    "dark:bg-purple-500",
    "dark:bg-red-500",
    "dark:text-primary-100",
    "dark:text-white",
    "flex",
    "font-medium",
    "h-1.5",
    "h-2.5",
    "h-4",
    "h-6",
    "justify-between",
    "leading-none",
    "mb-1",
    "overflow-hidden",
    "rounded-full",
    "space-x-2",
    "text-center",
    "text-primary-300",
    "w-full",
  ],
  Radio: [
    "appearance-none",
    "bg-[length:1em_1em]",
    "bg-center",
    "bg-gray-100",
    "bg-no-repeat",
    "border",
    "border-gray-300",
    "checked:bg-current",
    "checked:bg-dot-icon",
    "checked:border-transparent",
    "dark:bg-gray-700",
    "dark:border-gray-600",
    "dark:checked:bg-current",
    "dark:checked:border-transparent",
    "dark:focus:ring-blue-700",
    "dark:focus:ring-cyan-600",
    "dark:focus:ring-cyan-800",
    "dark:focus:ring-gray-800",
    "dark:focus:ring-gray-900",
    "dark:focus:ring-green-600",
    "dark:focus:ring-green-800",
    "dark:focus:ring-indigo-700",
    "dark:focus:ring-lime-700",
    "dark:focus:ring-pink-600",
    "dark:focus:ring-primary-600",
    "dark:focus:ring-purple-600",
    "dark:focus:ring-red-600",
    "dark:focus:ring-red-900",
    "dark:focus:ring-teal-600",
    "dark:focus:ring-yellow-400",
    "dark:ring-offset-blue-700",
    "dark:ring-offset-cyan-600",
    "dark:ring-offset-gray-800",
    "dark:ring-offset-gray-900",
    "dark:ring-offset-green-600",
    "dark:ring-offset-green-800",
    "dark:ring-offset-indigo-700",
    "dark:ring-offset-lime-700",
    "dark:ring-offset-pink-600",
    "dark:ring-offset-purple-600",
    "dark:ring-offset-red-600",
    "dark:ring-offset-red-900",
    "dark:ring-offset-teal-600",
    "dark:ring-offset-yellow-400",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-blue-600",
    "focus:ring-cyan-600",
    "focus:ring-cyan-800",
    "focus:ring-gray-800",
    "focus:ring-gray-900",
    "focus:ring-green-600",
    "focus:ring-green-800",
    "focus:ring-indigo-700",
    "focus:ring-lime-700",
    "focus:ring-offset-2",
    "focus:ring-pink-600",
    "focus:ring-primary-600",
    "focus:ring-purple-600",
    "focus:ring-red-600",
    "focus:ring-red-900",
    "focus:ring-teal-600",
    "focus:ring-yellow-400",
    "h-4",
    "rounded-full",
    "text-blue-700",
    "text-cyan-600",
    "text-cyan-800",
    "text-gray-800",
    "text-gray-900",
    "text-green-600",
    "text-green-800",
    "text-indigo-700",
    "text-lime-700",
    "text-pink-600",
    "text-primary-600",
    "text-purple-600",
    "text-red-600",
    "text-red-900",
    "text-teal-600",
    "text-yellow-400",
    "w-4",
  ],
  RangeSlider: [
    "appearance-none",
    "bg-gray-200",
    "cursor-pointer",
    "dark:bg-gray-700",
    "flex",
    "h-1",
    "h-2",
    "h-3",
    "relative",
    "rounded-lg",
    "w-full",
  ],
  Rating: [
    "bg-gray-200",
    "bg-yellow-400",
    "dark:bg-gray-700",
    "dark:text-cyan-500",
    "dark:text-gray-500",
    "flex",
    "font-medium",
    "h-10",
    "h-5",
    "h-7",
    "items-center",
    "mx-4",
    "rounded",
    "text-cyan-600",
    "text-gray-300",
    "text-sm",
    "text-yellow-400",
    "w-10",
    "w-2/4",
    "w-5",
    "w-7",
  ],
  Select: [
    "absolute",
    "appearance-none",
    "bg-[length:0.75em_0.75em]",
    "bg-[position:right_12px_center]",
    "bg-arrow-down-icon",
    "bg-cyan-50",
    "bg-gray-200",
    "bg-gray-50",
    "bg-green-50",
    "bg-no-repeat",
    "bg-red-50",
    "bg-yellow-50",
    "block",
    "border",
    "border-cyan-500",
    "border-gray-300",
    "border-green-500",
    "border-r-0",
    "border-red-500",
    "border-yellow-500",
    "dark:bg-cyan-100",
    "dark:bg-gray-600",
    "dark:bg-gray-700",
    "dark:bg-green-100",
    "dark:bg-red-100",
    "dark:bg-yellow-100",
    "dark:border-cyan-400",
    "dark:border-gray-600",
    "dark:border-green-400",
    "dark:border-red-400",
    "dark:border-yellow-400",
    "dark:focus:border-cyan-500",
    "dark:focus:border-green-500",
    "dark:focus:border-primary-500",
    "dark:focus:border-red-500",
    "dark:focus:border-yellow-500",
    "dark:focus:ring-cyan-500",
    "dark:focus:ring-green-500",
    "dark:focus:ring-primary-500",
    "dark:focus:ring-red-500",
    "dark:focus:ring-yellow-500",
    "dark:placeholder-gray-400",
    "dark:shadow-sm-light",
    "dark:text-gray-400",
    "dark:text-white",
    "disabled:cursor-not-allowed",
    "disabled:opacity-50",
    "flex",
    "focus:border-cyan-500",
    "focus:border-green-500",
    "focus:border-primary-500",
    "focus:border-red-500",
    "focus:border-yellow-500",
    "focus:outline-none",
    "focus:ring-1",
    "focus:ring-cyan-500",
    "focus:ring-green-500",
    "focus:ring-primary-500",
    "focus:ring-red-500",
    "focus:ring-yellow-500",
    "h-5",
    "inline-flex",
    "inset-y-0",
    "items-center",
    "left-0",
    "p-2",
    "p-2.5",
    "p-4",
    "pl-10",
    "pl-3",
    "placeholder-cyan-700",
    "placeholder-green-700",
    "placeholder-red-700",
    "placeholder-yellow-700",
    "pointer-events-none",
    "pr-10",
    "px-3",
    "relative",
    "rounded-l-md",
    "rounded-lg",
    "rounded-r-lg",
    "shadow-sm",
    "sm:text-base",
    "sm:text-xs",
    "text-cyan-900",
    "text-gray-500",
    "text-gray-900",
    "text-green-900",
    "text-red-900",
    "text-sm",
    "text-yellow-900",
    "w-5",
    "w-full",
  ],
  Sidebar: [
    "bg-cyan-50",
    "bg-dark-50",
    "bg-gray-100",
    "bg-gray-50",
    "bg-green-50",
    "bg-light-50",
    "bg-purple-50",
    "bg-red-50",
    "bg-yellow-50",
    "border-gray-200",
    "border-t",
    "dark:bg-cyan-900",
    "dark:bg-dark-900",
    "dark:bg-gray-700",
    "dark:bg-gray-800",
    "dark:bg-gray-900",
    "dark:bg-green-900",
    "dark:bg-light-900",
    "dark:bg-purple-900",
    "dark:bg-red-900",
    "dark:bg-yellow-900",
    "dark:border-gray-700",
    "dark:group-hover:text-white",
    "dark:hover:bg-gray-700",
    "dark:text-gray-100",
    "dark:text-gray-400",
    "dark:text-white",
    "delay-0",
    "duration-75",
    "ease-in-out",
    "first:border-t-0",
    "first:mt-0",
    "first:pt-0",
    "flex",
    "flex-1",
    "font-bold",
    "font-normal",
    "font-semibold",
    "group",
    "group-hover:text-gray-900",
    "h-6",
    "h-full",
    "hidden",
    "hover:bg-gray-100",
    "items-center",
    "justify-center",
    "mb-5",
    "ml-3",
    "mr-3",
    "mt-4",
    "mt-6",
    "overflow-x-hidden",
    "overflow-y-auto",
    "p-2",
    "p-4",
    "pl-2.5",
    "pl-8",
    "pt-4",
    "px-3",
    "py-2",
    "py-4",
    "rotate-180",
    "rounded",
    "rounded-lg",
    "self-center",
    "shrink-0",
    "sm:h-7",
    "space-y-2",
    "text-base",
    "text-gray-500",
    "text-gray-700",
    "text-gray-900",
    "text-left",
    "text-xl",
    "transition",
    "w-16",
    "w-6",
    "w-64",
    "w-full",
    "whitespace-nowrap",
  ],
  Spinner: [
    "animate-spin",
    "dark:fill-gray-300",
    "dark:text-gray-600",
    "fill-cyan-600",
    "fill-gray-600",
    "fill-green-500",
    "fill-pink-600",
    "fill-primary-600",
    "fill-purple-600",
    "fill-red-600",
    "fill-yellow-400",
    "h-10",
    "h-3",
    "h-4",
    "h-6",
    "h-8",
    "inline",
    "text-gray-200",
    "w-10",
    "w-3",
    "w-4",
    "w-6",
    "w-8",
  ],
  Table: [
    "-z-10",
    "absolute",
    "bg-gray-50",
    "bg-white",
    "dark:bg-black",
    "dark:bg-gray-700",
    "dark:hover:bg-gray-600",
    "dark:text-gray-400",
    "drop-shadow-md",
    "even:bg-gray-50",
    "even:dark:bg-gray-700",
    "group-first/body:group-first/row:first:rounded-tl-lg",
    "group-first/body:group-first/row:last:rounded-tr-lg",
    "group-first/head:first:rounded-tl-lg",
    "group-first/head:last:rounded-tr-lg",
    "group-last/body:group-last/row:first:rounded-bl-lg",
    "group-last/body:group-last/row:last:rounded-br-lg",
    "group/body",
    "group/head",
    "group/row",
    "h-full",
    "hover:bg-gray-50",
    "left-0",
    "odd:bg-white",
    "odd:dark:bg-gray-800",
    "px-6",
    "py-3",
    "py-4",
    "relative",
    "rounded-lg",
    "text-gray-500",
    "text-gray-700",
    "text-left",
    "text-sm",
    "text-xs",
    "top-0",
    "uppercase",
    "w-full",
  ],
  Tabs: [
    "-mb-px",
    "bg-gray-100",
    "bg-primary-600",
    "bg-white",
    "border-b",
    "border-b-2",
    "border-gray-200",
    "border-primary-600",
    "border-transparent",
    "dark:bg-gray-700",
    "dark:bg-gray-800",
    "dark:border-gray-700",
    "dark:border-primary-500",
    "dark:divide-gray-700",
    "dark:hover:bg-gray-700",
    "dark:hover:bg-gray-800",
    "dark:hover:text-gray-300",
    "dark:hover:text-white",
    "dark:text-gray-400",
    "dark:text-primary-500",
    "dark:text-white",
    "disabled:cursor-not-allowed",
    "disabled:dark:text-gray-500",
    "disabled:text-gray-400",
    "divide-gray-200",
    "divide-x",
    "first:ml-0",
    "flex",
    "flex-col",
    "flex-wrap",
    "focus:outline-none",
    "font-medium",
    "gap-2",
    "grid",
    "grid-flow-col",
    "h-5",
    "hover:bg-gray-100",
    "hover:bg-gray-50",
    "hover:border-gray-300",
    "hover:text-gray-600",
    "hover:text-gray-700",
    "hover:text-gray-900",
    "items-center",
    "justify-center",
    "ml-0",
    "mr-2",
    "p-4",
    "py-3",
    "rounded-lg",
    "rounded-none",
    "rounded-t-lg",
    "shadow",
    "space-x-2",
    "text-center",
    "text-gray-500",
    "text-gray-900",
    "text-primary-600",
    "text-sm",
    "text-white",
    "w-5",
    "w-full",
  ],
  TextInput: [
    "absolute",
    "bg-cyan-50",
    "bg-gray-200",
    "bg-gray-50",
    "bg-green-50",
    "bg-red-50",
    "bg-yellow-50",
    "block",
    "border",
    "border-cyan-500",
    "border-gray-300",
    "border-green-500",
    "border-r-0",
    "border-red-500",
    "border-yellow-500",
    "dark:bg-cyan-100",
    "dark:bg-gray-600",
    "dark:bg-gray-700",
    "dark:bg-green-100",
    "dark:bg-red-100",
    "dark:bg-yellow-100",
    "dark:border-cyan-400",
    "dark:border-gray-600",
    "dark:border-green-400",
    "dark:border-red-400",
    "dark:border-yellow-400",
    "dark:focus:border-cyan-500",
    "dark:focus:border-green-500",
    "dark:focus:border-primary-500",
    "dark:focus:border-red-500",
    "dark:focus:border-yellow-500",
    "dark:focus:ring-cyan-500",
    "dark:focus:ring-green-500",
    "dark:focus:ring-primary-500",
    "dark:focus:ring-red-500",
    "dark:focus:ring-yellow-500",
    "dark:placeholder-gray-400",
    "dark:shadow-sm-light",
    "dark:text-gray-400",
    "dark:text-white",
    "disabled:cursor-not-allowed",
    "disabled:opacity-50",
    "flex",
    "focus:border-cyan-500",
    "focus:border-green-500",
    "focus:border-primary-500",
    "focus:border-red-500",
    "focus:border-yellow-500",
    "focus:outline-none",
    "focus:ring-1",
    "focus:ring-cyan-500",
    "focus:ring-green-500",
    "focus:ring-primary-500",
    "focus:ring-red-500",
    "focus:ring-yellow-500",
    "h-5",
    "inline-flex",
    "inset-y-0",
    "items-center",
    "left-0",
    "p-2",
    "p-2.5",
    "p-4",
    "pl-10",
    "pl-3",
    "placeholder-cyan-700",
    "placeholder-gray-500",
    "placeholder-green-700",
    "placeholder-red-700",
    "placeholder-yellow-700",
    "pointer-events-none",
    "pr-10",
    "pr-3",
    "px-3",
    "relative",
    "right-0",
    "rounded-l-md",
    "rounded-lg",
    "rounded-r-lg",
    "shadow-sm",
    "sm:text-base",
    "sm:text-xs",
    "text-cyan-900",
    "text-gray-500",
    "text-gray-900",
    "text-green-900",
    "text-red-900",
    "text-sm",
    "text-yellow-900",
    "w-5",
    "w-full",
  ],
  Textarea: [
    "bg-cyan-50",
    "bg-gray-50",
    "bg-green-50",
    "bg-red-50",
    "bg-yellow-50",
    "block",
    "border",
    "border-cyan-500",
    "border-gray-300",
    "border-green-500",
    "border-red-500",
    "border-yellow-500",
    "dark:bg-cyan-100",
    "dark:bg-gray-700",
    "dark:bg-green-100",
    "dark:bg-red-100",
    "dark:bg-yellow-100",
    "dark:border-cyan-400",
    "dark:border-gray-600",
    "dark:border-green-400",
    "dark:border-red-400",
    "dark:border-yellow-400",
    "dark:focus:border-cyan-500",
    "dark:focus:border-green-500",
    "dark:focus:border-primary-500",
    "dark:focus:border-red-500",
    "dark:focus:border-yellow-500",
    "dark:focus:ring-cyan-500",
    "dark:focus:ring-green-500",
    "dark:focus:ring-primary-500",
    "dark:focus:ring-red-500",
    "dark:focus:ring-yellow-500",
    "dark:placeholder-gray-400",
    "dark:shadow-sm-light",
    "dark:text-white",
    "disabled:cursor-not-allowed",
    "disabled:opacity-50",
    "focus:border-cyan-500",
    "focus:border-green-500",
    "focus:border-primary-500",
    "focus:border-red-500",
    "focus:border-yellow-500",
    "focus:outline-none",
    "focus:ring-1",
    "focus:ring-cyan-500",
    "focus:ring-green-500",
    "focus:ring-primary-500",
    "focus:ring-red-500",
    "focus:ring-yellow-500",
    "p-2.5",
    "placeholder-cyan-700",
    "placeholder-green-700",
    "placeholder-red-700",
    "placeholder-yellow-700",
    "rounded-lg",
    "shadow-sm",
    "text-cyan-900",
    "text-gray-900",
    "text-green-900",
    "text-red-900",
    "text-sm",
    "text-yellow-900",
    "w-full",
  ],
  Timeline: [
    "-left-1.5",
    "-left-3",
    "absolute",
    "bg-gray-200",
    "bg-primary-200",
    "border",
    "border-gray-200",
    "border-l",
    "border-white",
    "dark:bg-gray-700",
    "dark:bg-primary-900",
    "dark:border-gray-700",
    "dark:border-gray-900",
    "dark:ring-gray-900",
    "dark:text-gray-400",
    "dark:text-gray-500",
    "dark:text-primary-300",
    "dark:text-white",
    "flex",
    "font-normal",
    "font-semibold",
    "h-0.5",
    "h-3",
    "h-6",
    "hidden",
    "items-center",
    "justify-center",
    "leading-none",
    "mb-1",
    "mb-10",
    "mb-4",
    "mb-6",
    "ml-6",
    "mt-1.5",
    "mt-3",
    "relative",
    "ring-8",
    "ring-white",
    "rounded-full",
    "sm:flex",
    "sm:mb-0",
    "sm:pr-8",
    "text-base",
    "text-gray-400",
    "text-gray-500",
    "text-gray-900",
    "text-lg",
    "text-primary-600",
    "text-sm",
    "w-3",
    "w-6",
    "w-full",
  ],
  Toast: [
    "-m-1.5",
    "bg-white",
    "dark:bg-gray-800",
    "dark:hover:bg-gray-700",
    "dark:hover:text-white",
    "dark:text-gray-400",
    "dark:text-gray-500",
    "ease-out",
    "flex",
    "focus:ring-2",
    "focus:ring-gray-300",
    "h-5",
    "h-8",
    "hover:bg-gray-100",
    "hover:text-gray-900",
    "inline-flex",
    "items-center",
    "max-w-xs",
    "ml-auto",
    "opacity-0",
    "p-1.5",
    "p-4",
    "rounded-lg",
    "shadow",
    "shrink-0",
    "text-gray-400",
    "text-gray-500",
    "w-5",
    "w-8",
    "w-full",
  ],
  ToggleSwitch: [
    "after:absolute",
    "after:bg-white",
    "after:border",
    "after:border-gray-300",
    "after:border-transparent",
    "after:h-4",
    "after:h-5",
    "after:h-6",
    "after:left-0.5",
    "after:rounded-full",
    "after:top-0.5",
    "after:transition-all",
    "after:translate-x-full",
    "after:w-4",
    "after:w-5",
    "after:w-6",
    "bg-blue-700",
    "bg-cyan-500",
    "bg-cyan-600",
    "bg-gray-200",
    "bg-gray-300",
    "bg-gray-500",
    "bg-gray-700",
    "bg-green-500",
    "bg-green-600",
    "bg-indigo-400",
    "bg-lime-400",
    "bg-pink-600",
    "bg-primary-700",
    "bg-purple-700",
    "bg-red-700",
    "bg-teal-400",
    "bg-yellow-400",
    "bg-yellow-600",
    "cursor-not-allowed",
    "cursor-pointer",
    "dark:bg-gray-700",
    "dark:group-focus:ring-blue-800",
    "dark:group-focus:ring-cyan-800",
    "dark:group-focus:ring-gray-800",
    "dark:group-focus:ring-green-800",
    "dark:group-focus:ring-indigo-800",
    "dark:group-focus:ring-lime-800",
    "dark:group-focus:ring-pink-800",
    "dark:group-focus:ring-primary-800",
    "dark:group-focus:ring-purple-800",
    "dark:group-focus:ring-red-800",
    "dark:group-focus:ring-teal-800",
    "dark:group-focus:ring-yellow-800",
    "dark:text-gray-300",
    "flex",
    "focus:outline-none",
    "font-medium",
    "group",
    "group-focus:ring-4",
    "group-focus:ring-blue-300",
    "group-focus:ring-cyan-300",
    "group-focus:ring-gray-300",
    "group-focus:ring-green-300",
    "group-focus:ring-indigo-300",
    "group-focus:ring-lime-300",
    "group-focus:ring-pink-300",
    "group-focus:ring-primary-300",
    "group-focus:ring-purple-300",
    "group-focus:ring-red-300",
    "group-focus:ring-teal-300",
    "group-focus:ring-yellow-300",
    "h-5",
    "h-6",
    "h-7",
    "min-w-11",
    "min-w-9",
    "min-w-[52px]",
    "ms-3",
    "mt-0.5",
    "opacity-50",
    "relative",
    "rounded-full",
    "rounded-lg",
    "rtl:after:-translate-x-full",
    "rtl:after:right-0.5",
    "text-gray-900",
    "text-sm",
    "text-start",
    "w-11",
    "w-9",
    "w-[52px]",
  ],
  Tooltip: [
    "-4px",
    "absolute",
    "bg-gray-900",
    "bg-white",
    "border",
    "border-gray-200",
    "dark:bg-gray-700",
    "dark:border-none",
    "dark:text-white",
    "font-medium",
    "h-2",
    "inline-block",
    "invisible",
    "opacity-0",
    "px-3",
    "py-2",
    "relative",
    "rotate-45",
    "rounded-lg",
    "shadow-sm",
    "text-gray-900",
    "text-sm",
    "text-white",
    "transition-opacity",
    "w-2",
    "w-fit",
    "z-10",
    "z-20",
  ],
};

export const COMPONENT_TO_CLASS_LIST_MAP = {
  Accordion: "Accordion",
  AccordionContent: "Accordion",
  AccordionTitle: "Accordion",
  Alert: "Alert",
  Avatar: "Avatar",
  AvatarGroup: "Avatar",
  AvatarGroupCounter: "Avatar",
  Badge: "Badge",
  Banner: "Banner",
  BannerCollapseButton: "Banner",
  Blockquote: "Blockquote",
  Breadcrumb: "Breadcrumb",
  BreadcrumbItem: "Breadcrumb",
  Button: "Button",
  ButtonGroup: "Button",
  Card: "Card",
  Carousel: "Carousel",
  Checkbox: "Checkbox",
  Clipboard: "Clipboard",
  ClipboardWithIcon: "Clipboard",
  ClipboardWithIconText: "Clipboard",
  DarkThemeToggle: "DarkThemeToggle",
  Datepicker: "Datepicker",
  Drawer: "Drawer",
  DrawerHeader: "Drawer",
  DrawerItems: "Drawer",
  Dropdown: "Dropdown",
  DropdownDivider: "Dropdown",
  DropdownHeader: "Dropdown",
  DropdownItem: "Dropdown",
  FileInput: "FileInput",
  FloatingLabel: "FloatingLabel",
  Footer: "Footer",
  FooterBrand: "Footer",
  FooterCopyright: "Footer",
  FooterDivider: "Footer",
  FooterIcon: "Footer",
  FooterLink: "Footer",
  FooterLinkGroup: "Footer",
  FooterTitle: "Footer",
  HR: "HR",
  HRIcon: "HR",
  HRSquare: "HR",
  HRText: "HR",
  HRTrimmed: "HR",
  HelperText: "HelperText",
  Kbd: "Kbd",
  Label: "Label",
  List: "List",
  ListItem: "List",
  ListGroup: "ListGroup",
  ListGroupItem: "ListGroup",
  MegaMenu: "MegaMenu",
  MegaMenuDropdown: "MegaMenu",
  MegaMenuDropdownToggle: "MegaMenu",
  Modal: "Modal",
  ModalBody: "Modal",
  ModalFooter: "Modal",
  ModalHeader: "Modal",
  Navbar: "Navbar",
  NavbarBrand: "Navbar",
  NavbarCollapse: "Navbar",
  NavbarLink: "Navbar",
  NavbarToggle: "Navbar",
  Pagination: "Pagination",
  PaginationButton: "Pagination",
  Popover: "Popover",
  Progress: "Progress",
  Radio: "Radio",
  RangeSlider: "RangeSlider",
  Rating: "Rating",
  RatingAdvanced: "Rating",
  RatingStar: "Rating",
  Select: "Select",
  Sidebar: "Sidebar",
  SidebarCTA: "Sidebar",
  SidebarCollapse: "Sidebar",
  SidebarItem: "Sidebar",
  SidebarItemGroup: "Sidebar",
  SidebarItems: "Sidebar",
  SidebarLogo: "Sidebar",
  Spinner: "Spinner",
  Table: "Table",
  TableBody: "Table",
  TableCell: "Table",
  TableHead: "Table",
  TableHeadCell: "Table",
  TableRow: "Table",
  TabItem: "Tabs",
  Tabs: "Tabs",
  TextInput: "TextInput",
  Textarea: "Textarea",
  Timeline: "Timeline",
  TimelineBody: "Timeline",
  TimelineContent: "Timeline",
  TimelineItem: "Timeline",
  TimelinePoint: "Timeline",
  TimelineTime: "Timeline",
  TimelineTitle: "Timeline",
  Toast: "Toast",
  ToastToggle: "Toast",
  ToggleSwitch: "ToggleSwitch",
  Tooltip: "Tooltip",
};
